import React from 'react';
import { EnvelopeSimpleIcon } from '@fronton/icons-react';
import {
  CATALOG_PAGE_PATH,
  SERVICES_PAGE_PATH,
  APRO_PAGE_PATH,
  CLIENT_SUPPORT_PAGE_PATH,
} from 'common/constants';
import { Drawer, DrawerHeader, DrawerContent, DrawerFooter } from 'common/components/left-drawer';
import { HeaderModelData } from 'types/model';
import { headerBackBtn } from 'components/header/styles/common';
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from 'components/language-selector';
import { useLangPickerExperiment } from 'common/hooks/use-experiments';
import { UseHamburgerMenuStateReturnType, useSideMenuAnalyticsEvent } from '../../hooks';
import { footerRoot, secondaryItemsRoot, footer, content } from './styles';
import { PrimaryMenuItem } from './primary-menu-item';
import { SecondaryMenuItem } from './secondary-menu-item';
import { MenuContentLayer } from '../menu-content-layer';
import { LemanaPro, LemanaStores } from '../../../icons';

export interface MainMenuProps extends UseHamburgerMenuStateReturnType {
  model: HeaderModelData;
}

export const MainMenu = (props: MainMenuProps) => {
  const { show, onMenuClose, model } = props;
  const { shops } = model.header;

  const { t } = useTranslation();

  const onCatalogClick = useSideMenuAnalyticsEvent('products');
  const onServicesClick = useSideMenuAnalyticsEvent('services');
  const onShopsClick = useSideMenuAnalyticsEvent('shops');
  const onClientServiceClick = useSideMenuAnalyticsEvent('clientService');

  const isLangPickerActive = useLangPickerExperiment();

  return (
    <Drawer onClose={onMenuClose} show={show}>
      <DrawerHeader title="" onClickBack={onMenuClose} className={headerBackBtn}>
        {isLangPickerActive && <LanguageSelector />}
      </DrawerHeader>
      <DrawerContent className={content}>
        <PrimaryMenuItem
          href={CATALOG_PAGE_PATH}
          title={t('header.sidebar.products.header')}
          subtitle={t('header.sidebar.products.description')}
          data-qa="catalog-link"
          onClick={onCatalogClick}
        />
        <PrimaryMenuItem
          href={SERVICES_PAGE_PATH}
          title={t('header.sidebar.services.header')}
          subtitle={t('header.sidebar.services.description')}
          data-qa="services-page-link"
          onClick={onServicesClick}
        />
        <MenuContentLayer vertical className={secondaryItemsRoot}>
          <SecondaryMenuItem
            href={shops}
            title={t('header.sidebar.misc.stores')}
            customIcon={<LemanaStores />}
            onClick={onShopsClick}
            data-qa="store-link"
          />
          <SecondaryMenuItem
            href={APRO_PAGE_PATH}
            title={t('header.sidebar.misc.b2b')}
            customIcon={<LemanaPro />}
            onClick={onShopsClick}
            data-qa="store-link"
          />
        </MenuContentLayer>
      </DrawerContent>
      <DrawerFooter className={footer}>
        <div className={footerRoot}>
          <SecondaryMenuItem
            href={CLIENT_SUPPORT_PAGE_PATH}
            title={t('header.sidebar.misc.support')}
            icon={EnvelopeSimpleIcon}
            data-qa="client-support-link"
            onClick={onClientServiceClick}
          />
        </div>
      </DrawerFooter>
    </Drawer>
  );
};
